import styled from '@emotion/styled';
import { Colors, Flex, IconCheckSmallLine, PrimaryColors, Text } from '@revenuemarket/cds';
import { RefinedCodefCert } from '~types/codef';

interface Props {
  selected: boolean;
  item: RefinedCodefCert;
  setSelectedCertificate: (certificate: RefinedCodefCert) => void;
}

const Badge = styled.div`
  display: flex;
  height: 20px;
  padding: 8px 4px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: 5px;
  background: var(--GrayOpacity07, rgba(29, 34, 37, 0.07));
`;

const CertItemWrapper = styled(Flex)<{ selected: boolean }>`
  padding: 12px;
  gap: 12px;
  width: 100%;
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? PrimaryColors.primary50 : Colors.gray30)};
  border-radius: 12px;
  border: 1px solid ${({ selected }) => (selected ? PrimaryColors.primary200 : Colors.gray30)};
  &:hover {
    background-color: ${({ selected }) => (selected ? PrimaryColors.primary50 : Colors.gray100)};
    border-color: ${({ selected }) => (selected ? PrimaryColors.primary200 : Colors.gray100)};
  }
`;

const CertItemRegisteredWrapper = styled(Flex)`
  padding: 12px;
  gap: 12px;
  width: 100%;
  cursor: default;
  background-color: ${Colors.gray30};
  border-radius: 12px;
  & span {
    color: ${Colors.gray400} !important;
  }
`;

const CertItem = ({ selected, item, setSelectedCertificate }: Props) => {
  return (
    <CertItemWrapper
      selected={selected}
      align="center"
      onClick={() => setSelectedCertificate(item)}
    >
      <IconCheckSmallLine
        width={32}
        height={32}
        fill={selected ? PrimaryColors.primary600 : Colors.grayOpacity07}
      />
      <Flex direction="column" gap={2}>
        <Text
          textStyle="13_600"
          style={{
            color: Colors.gray900,
          }}
        >
          {item.certificateOwner}
        </Text>
        <Text
          textStyle="13_400"
          style={{
            color: Colors.gray600,
          }}
        >
          {item.certificateAuthority || '금융결제원'}
          {' · '}
          {item.certificateType || '전자세금용'}
        </Text>
        <Text
          textStyle="13_400"
          style={{
            color: Colors.gray600,
          }}
        >
          만료일 {item.certificateExpireDate}
        </Text>
      </Flex>
    </CertItemWrapper>
  );
};

export default CertItem;
